import { render, staticRenderFns } from "./file2.vue?vue&type=template&id=3ef0e1e4&scoped=true"
import script from "./file2.vue?vue&type=script&lang=js"
export * from "./file2.vue?vue&type=script&lang=js"
import style0 from "./file2.vue?vue&type=style&index=0&id=3ef0e1e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef0e1e4",
  null
  
)

export default component.exports